import { setTransactions } from '../../store/transactionsSlice';
import { setPositions } from '../../store/positionsSlice';
import { setOrders } from "../../store/ordersSlice";
import { setBalance } from "../../store/accountSlice";
import { setEntities } from '../../store/entitiesSlice';
import { setMarginHolds } from '../../store/marginHoldSlice';
import { setCommodities } from '../../store/commoditiesSlice';
import { mixpanelTrack } from '../../App';

// const API_URL = process.env.REACT_APP_STORIES_API_URL;

/*

/orders
http://localhost:8080/orders/





*/

export const fetchEntitiesFromApi = async () => {
  try {
    const res = await fetch('http://localhost:8080/entities');
    if (!res.ok) throw new Error('Failed to fetch entities');
    const data = await res.json();
    return data.entities || [];
  } catch (err) {
    console.error('Error fetching entities:', err);
    return [];
  }
};

// Fetch orders for a user and dispatch to Redux
export const fetchOrdersForUser = async (userId, dispatch) => {
  if (!userId) return;

  const url = process.env.REACT_APP_USER_ORDERS_URL;

  try {
    const res = await fetch(`${url}/${userId}`);
    const data = await res.json();
    if (data.orders) {
      dispatch(setOrders(data.orders));
    }
  } catch (err) {
    console.error('Error fetching user orders:', err);
  }
};

export const fetchEntities = async (dispatch) => {
  try {
    const res = await fetch('http://localhost:8080/entities');
    if (!res.ok) throw new Error('Failed to fetch entities');
    const data = await res.json();
    if (data.entities) {
      dispatch(setEntities(data.entities));
      //dispatch({ type: 'entities/setEntities', payload: data.entities });
    }
  } catch (err) {
    console.error('Error fetching entities:', err);
  }
};

  export const saveOrder = async (order, userId) => {
    // Save order to backend database

    mixpanelTrack('Order Created', {userId, ...order});

    const url = process.env.REACT_APP_USER_ORDERS_ADD_URL;
      try {
        await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ order: {userId, ...order}}),
        });
      } catch (err) {
        console.error('Error saving order to backend:', err);
      }
    };

export const saveEntityToAPI = async (entity) => {
  try {
    const res = await fetch('http://localhost:8080/entity/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({entity}),
    });
    const data = await res.json();
    return data.message || 'Saved';
  } catch (err) {
    return 'Error saving entity';
  }
};

export const updateEntityToAPI = async (entity) => {
  try {
    const res = await fetch('http://localhost:8080/entity/update', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({entity}),
    });
    const data = await res.json();
    return data.message || 'Saved';
  } catch (err) {
    return 'Error saving entity';
  }
};

export const updateOrderStatusToAPI = async (orderId, status) => {
  try {
    fetch('http://localhost:8080/order/update-status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderId, status })
    })
    .then(res => res.json());
  } catch (err) {
    return 'Error saving entity';
  }
};

export const setAccountBalance = async (userId, balance) => {
  mixpanelTrack('Account Balance Updated', {userId, balance});
  const url = process.env.REACT_APP_SET_ACCOUNT_BALANCE_URL;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, balance })
    });
    const data = await res.json();
    return data.message || 'Success';
  } catch (err) {
    return 'Error setting account balance';
  }
};

export const getAccountBalance = async (userId, dispatch) => {
  const url = process.env.REACT_APP_USER_ACCOUNT_BALANCE_URL;
  try {
    const res = await fetch(`${url}/${userId}`);
    if (!res.ok) throw new Error('Failed to fetch account balance');
    const data = await res.json();
    const bal = data.balance;
    // console.log('Fetched account balance:', bal);
    if (typeof bal === 'number') dispatch(setBalance(bal));
  } catch (err) {
    console.error('Error fetching account balance:', err);
  }
};

// Fetch positions for a user and dispatch to Redux
export const fetchPositionsForUser = async (userId, dispatch) => {
  if (!userId) return;
  const url = process.env.REACT_APP_USER_POSITIONS_URL;
  try {
    const res = await fetch(`${url}/${userId}`);
    if (!res.ok) throw new Error('Failed to fetch positions');
    const data = await res.json();
    if (data.positions) {
      dispatch(setPositions(data.positions));
    }
  } catch (err) {
    console.error('Error fetching user positions:', err);
  }
};

// Fetch transactions for a user and dispatch to Redux
export const fetchTransactionsForUser = async (userId, dispatch) => {
  if (!userId) return;
  const url = process.env.REACT_APP_USER_TRANSACTIONS_URL;
  try {
    const res = await fetch(`${url}/${userId}`);
    if (!res.ok) throw new Error('Failed to fetch transactions');
    const data = await res.json();
    if (data.transactions) {
      dispatch(setTransactions(data.transactions));
    }
  } catch (err) {
    console.error('Error fetching user transactions:', err);
  }
};

export const closePositionAPI = async (positionId) => {
  mixpanelTrack('Position Closed', {positionId});
  const url = process.env.REACT_APP_USER_POSITION_CLOSE_URL;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ positionId })
    });
    const data = await res.json();
    return data;
  } catch (err) {
    console.error('Error closing position:', err);
    return { status: 'error', message: 'Error closing position', error: err };
  }
};

// Fetch margin holds for a user and dispatch to Redux
export const fetchMarginHoldsForUser = async (userId, dispatch) => {
  if (!userId) return;
  const url = process.env.REACT_APP_USER_MARGIN_HOLDS_URL;
  try {
    const res = await fetch(`${url}/${userId}`);
    if (!res.ok) throw new Error('Failed to fetch margin holds');
    const data = await res.json();
    if (data.marginHolds) {
      dispatch(setMarginHolds(data.marginHolds));
    }
  } catch (err) {
    console.error('Error fetching margin holds:', err);
  }
};

export const addCommodityToApi = async (commodity) => {
  const url = process.env.REACT_APP_ADD_COMMODITY_URL;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ commodity })
    });
    const data = await res.json();
    return data;
  } catch (err) {
    console.error('Error adding commodity:', err);
    return { status: 'error', message: 'Error adding commodity', error: err };
  }
};

// Fetch active commodities and dispatch to Redux
export const fetchActiveCommodities = async (dispatch) => {
  const url = process.env.REACT_APP_ACTIVE_COMMODITIES_URL;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error('Failed to fetch active commodities');
    const data = await res.json();
    if (data.commodities) {
      dispatch(setCommodities(data.commodities));
    }
  } catch (err) {
    console.error('Error fetching active commodities:', err);
  }
};

export const updateBidAskToApi = async (symbol, bid, ask) => {
  const url = process.env.REACT_APP_UPDATE_COMMODITY_BID_ASK_URL;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ symbol, bid, ask })
    });
    const data = await res.json();
    return data;
  } catch (err) {
    console.error('Error updating bid/ask:', err);
    return { status: 'error', message: 'Error updating bid/ask', error: err };
  }
};
